import { Suspense, lazy } from "react";
import PageErrorBoundary from "../../components/PageErrorBoundary";
import Loading from "../../components/Loading";


const EditLocationPage = lazy(() => import('./Index'))

const SuspendedEditLocationPage  = (props:any) =>
<PageErrorBoundary>
<Suspense fallback={<Loading/>}>
<EditLocationPage {...props}/>
</Suspense>

</PageErrorBoundary>


export default SuspendedEditLocationPage;